export const actions = {
  SET_REVIEW: 'SET_REVIEW',
  SET_REVIEW_SETTINGS: 'SET_REVIEW_SETTINGS',
};
